import CategoryCard from "../components/CategoryCard";
import Typewriter from "typewriter-effect";
import { useRef, useEffect, useState } from "react";
import Slider from "react-slick";
import AddonCard from "../components/AddonCard";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { NavLink } from "react-router-dom";
import { getAddons, getAppSeting, getSlides, getGallery, getReview } from "../http";

import {Accordion, AccordionDetails, AccordionSummary} from '@mui/material'



const Home = () => {

    const typingRef = useRef(null)

    const [addons, setAddons] = useState([]);
    const [app, setApp] = useState({});

    const [slides, setSlides] = useState([])
    const [review, setReview] = useState([]);

    const [gallery, setGallery] = useState([]);
        const [bigGallery, setBigGallery] = useState(false)
        const [act, setAct] = useState();

        const [expanded, setExpanded] = useState(false)

        const handleChange = (panel) => (event, isExpanded) => {
           setExpanded(isExpanded ? panel : false);
    };
    
        useEffect(() => {
            const fetchGallery = async () => {
                try {
                    const {data} = await getGallery();
                    setGallery(data.gallery)
                } catch (error) {
                    console.log(error)
                }
            }
            fetchGallery();
        }, [])

        useEffect(() => {
            const fetchReview = async () => {
                try {
                    const {data} = await getReview();
                    setReview(data.review)
                } catch (error) {
                    console.log(error)
                }
            }
            fetchReview();
        }, [])

        useEffect(() => {
          //window.location.reload()
        }, [])
    
    
        var settings = {
            dots: false,
            infinite: true,
            speed: 3000,
            auto: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            spacing: 0,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        };
    
        const handleGal = (act) => {
           setAct(act)
           setBigGallery(true)
        }
    
    

    

    useEffect(() => {
        const fetchAddons = async () => {
          try {
    
            const {data} = await getAddons();
            const res = await getAppSeting();
            setApp(res.data.setting)
            setAddons(data.addons)
            
          } catch (error) {
            console.log(error)
          }
        }
        fetchAddons()
      }, [])

      useEffect(() => {
        const fetchSlides = async () => {
            try {
                const {data} = await getSlides();
                setSlides(data.slides)
            } catch (error) {
                console.log(error)
            }
        }
        fetchSlides();
      }, [])


    var settings = {
        dots: false,
        infinite: true,
        speed: 3000,
        auto: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed:2000,
        spacing: 40,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    };

  

  


    return (
        <div>


      {/* Hero Section */}
         {/* <section id="hero-section" style={{backgroundImage: `url(${app.banner_image}), linear-gradient(90deg, #33193a, #d4ced5)`}}>
           
           <div className="my-container">
                <div className="row">
                    <div className="hero-content">
                        <div className="content" >
                            <div className="hero-h-box" style={{minHeight: '220px'}}>
                            <Slider {...settings} slidesToShow={1} arrows={false} autoplaySpeed={1000} speed={2000}>
                              <h1 className="hero-heading">Your Event Starts With Us</h1>
                              <h1 className="hero-heading">Every event is special but yours should be unique</h1>
                              <h1 className="hero-heading">Enjoy the view with your special ones on the big screen with Binge N Fiesta</h1>
                            </Slider>

                            </div>
                            <p className="text light" style={{fontSize: '20px'}}>
                            Celebrate your event with a Dolby Atmos and extended 4K video system can elevate the experience to new heights 
                            </p>
                            <NavLink to={'/booknow'}><button type="button" class="btn btn-gradient btn-border">Book Now</button></NavLink>
                        </div>
                    </div>
                </div>

            </div>
        </section> */}

        <section id="crousel" className="crousel">
            <Slider arrows={true} autoplay={true} autoplaySpeed={2000} dots={true} >
                
                {
                    slides.map((slide) => (
                        <div className="item">
                    <div className="img" style={{backgroundImage: `url(${slide.image})`}}>
                    <div className="content">
                       <h1 className="hero-heading">{slide.heading}</h1>
                       <p className="text light" style={{fontSize: '20px'}}>
                            {slide.description}
                        </p>
                        <NavLink to={'/booknow'}><button type="button" class="btn btn-gradient btn-border">Book Now</button></NavLink>
                    </div>
                    </div>
                    
                </div>
                    ))
                }

            </Slider>

          
        </section>

        


        {/* section two */}


        <section id="cat">
        <div className="my-container">
      <div id="carouselId" className="carousel slide" data-ride="carousel" style={{ marginTop: '5%' }}>
        <div className="carousel-inner" role="listbox">
          <div className="carousel-item">
            <div className="card-deck">
             <Slider {...settings}>
             <CategoryCard
                title="Birthday Party"
                text="Celebrate your birthday in style with our private theatre experience. Enjoy watching your favorite movies."
                image={'/assets/img/bday.png'}
              />
               <CategoryCard
                title="Anniversaries"
                text="Mark your milestone anniversary with a romantic and intimate private theatre celebration."
                image={'/assets/img/pic22.png'}
              />
               <CategoryCard
                title="Farewell Parties"
                text="Bid farewell in an unforgettable way with our event services. Celebrate cherished memories."
                image={'/assets/img/fwell.png'}
              />
               <CategoryCard
                title="Bride to Be"
                text="Make her feel special with a celebration to remember. Our tailored experiences are perfect."
                image={'/assets/img/pic22.png'}
              />
               <CategoryCard
                title="MOM to Be"
                text="Celebrate the upcoming arrival with a beautiful and intimate gathering. Our services cater to every need."
                image={'/assets/img/pic22.png'}
              />
              <CategoryCard
                title="Love Proposal"
                text=" Pop the question in a setting as special as your love. Our proposal experiences create a magic."
                image={'/assets/img/pic22.png'}
              />
              <CategoryCard
                title="Events"
                text="Whether it's a reunion, farewell, or any other social gathering, our private theatres provide a unique venue"
                image={'/assets/img/pic22.png'}
              />
             </Slider>
             
            </div>
          </div>
         
        </div>
      </div>
    </div>
        </section>


        {/* Section  Three */}
            <section id="about">
                <div className="my-container">
                    <div class="row">
                        <div className="col abt-col-left">
                            <img style={{borderRadius: '8px'}} src={app.banner_image} alt="" />
                        </div>
                        <div className="col col-vertical-center abt-col-right">
                            <div>
                            <span className="accent-heading">About US</span>
                            <h1 className="heading-primary">Best Private Theaters <br />in  <span className="gradient-text">Hyderabad</span> </h1>
                            <p className="text">Welcome to Binge N Fiesta. We believe that every moment is worth celebrating. Our luxurious private home theater is designed to transport you into a world of cinematic magic, where you can create unforgettable memories with your loved ones. Whether it's a birthday, anniversary or any special occasions, we have got you covered.</p>
                            <a target="_blank" href="https://maps.app.goo.gl/gGkS9wueVypMwDc69"><div className="locations">
                                <div className="location-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt" viewBox="0 0 16 16">
  <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10"/>
  <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/>
</svg>
                                </div>
                                <div className="location-content">
                                   <h2 className="sub-heading color-primary">Our location</h2> 
                                   <p style={{margin: '0', color: '#000'}} className="text">Currently we are serving in TNGO Colony, Near Gowlidoddi, Gachibowli, Soon we will come to your city.</p>
                                </div>
                             </div></a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        {/* Section Four */}
            <section id="how-work">
                <div className="my-container">
                    <center> <h1 class="heading-primary">How It Works</h1></center>
                    <div className="row" style={{marginTop:'170px'}}>
                        <div className="col how-card theater" style={{ width: 'calc(33.33% - 40px)' }}>
                            <div className="card-body">
                                <center>
                                <h2 className="sub-heading color-primary">Booking The Theatre</h2>
                                <p className="text">You can check available slots and book the theatre from this website. For more details you can contact us on +91 95021 90061 (WhatsApp Only)</p>
                                <NavLink to={'/booknow'}><button type="button" class="btn btn-gradient btn-border" style={{marginTop: '20px'}}>Book Now</button></NavLink>
                                </center>
                            
                            </div>
                        </div>

                        <div className="col how-card decoration" style={{ width: 'calc(33.33% - 40px)' }}>
                            <div className="card-body">
                                <center>
                                <h2 className="sub-heading color-primary">Special Decorations</h2>
                                <p className="text">Want to make your loved ones feel special? Get the private theatre beautifully decorated at just Rs 399. Decoration can be added while booking.</p>
                                <NavLink to={'/booknow'}><button type="button" class="btn btn-gradient btn-border" style={{marginTop: '20px'}}>Book Now</button></NavLink>
                                </center>
                            </div>
                        </div>

                        <div className="col how-card ott" style={{ width: 'calc(33.33% - 40px)' }}>
                            <div className="card-body">
                                <center>
                                <h2 className="sub-heading color-primary">What Can You Watch?</h2>
                                <p className="text">We do NOT provide any content. You can use any of your OTT account or downloads to watch your favorite content. We will do all the setup for you</p>
                                <NavLink to={'/booknow'}><button type="button" class="btn btn-gradient btn-border" style={{marginTop: '20px'}}>Book Now</button></NavLink>
                                </center>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </section>




       {/* Section Five */}
            <section id="addon">
                <div className="my-container">
                    <center><h1 class="heading-primary">Picks <span className="gradient-text">
                        Add-Ons
                    </span> </h1></center>

                    <div style={{marginTop: '30px'}}>
                        <Slider {...settings} >
                            {
                                addons.map((addon) => <AddonCard addon={addon} noPrice={true} />)
                            }
                        </Slider>
                    </div>
                </div>
            </section>

            <section id="addon" style={{background: '#F9E9FE'}}>
                <div className="my-container">
                    <center><h1 class="heading-primary">Our <span className="gradient-text">
                        Review
                    </span> </h1></center>

                    <div style={{marginTop: '30px'}}>
                        <Slider {...settings} sp >
                          {
                            review.map((rev) => (
                                <div className="rev-box">
                                    <div className="rev-inner">
                                      <img src={rev.image} alt="review" />
                                    </div>
                                </div>
                            ))
                          }
                        </Slider>
                    </div>
                </div>
            </section>


            <section id="addon" style={{background: '#F9E9FE'}}>
                <div className="my-container">
                    <center><h1 class="heading-primary">Our <span className="gradient-text">
                        Testimonials
                    </span> </h1></center>

                    <div style={{marginTop: '30px'}}>
                        <Slider {...settings} >
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/DQxdN2rGCr8?si=jBKIaWhmEJc7P9dJ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/heGSuuQBbhw?si=v_AsGDRbYZnE2GbZ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/PibDFeCChDg?si=Wak72OTKPCN2pRUZ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </Slider>
                    </div>
                </div>
            </section>

            {/* review */}

            <section id="Gallery" style={{padding: '70px 0',}}>
                <div className="my-container">
                    <center><h1 class="heading-primary">Gallery <span className="gradient-text">
                        
                    </span> </h1></center>

                    <div style={{marginTop: '30px'}}>
                    <div className="gallery-grid">
                       
                       {
                        gallery.map((gl) => (
                            <div className="gallery-item">
                                <img onClick={() => handleGal(gl.image)} alt="thumbnail" src={gl.image} />
                            </div>
                        ))
                       }

                       {
                        bigGallery ? (
                            <div className="gal-overlay" >
                                <div className="gallery-box">
                                <button style={{padding: '0', background: 'transparent', color: 'white', marginBottom: '30px', textAlign: 'right', display: 'inline'}} className="btn" onClick={() => setBigGallery(false)}><i className="fa fa-times"></i></button>
                                    <div>
                                        <Slider {...settings}>
                                                <div className="gallery-item">
                                                    <img alt="thumbnail" src={act} />
                                                </div>
                                            {
                                                gallery.map((gl) => (
                                                    <div className="gallery-item">
                                                        <img alt="thumbnail" src={gl.image} />
                                                    </div>
                                                ))
                                            }
                                        </Slider>
                                    </div>
                                </div>
                            </div>
                        ) : null
                       }
                        
                
                    </div>
                    </div>
                </div>
            </section>


          

            <section id="faq" style={{padding: '70px 0', background: '#F9E9FE'}}>
                <div className="my-container">
                    <center><h1 class="heading-primary">Our <span className="gradient-text">
                        FAQ's
                    </span> </h1></center>

                    <div style={{margin: '30px auto 0 auto', maxWidth: '700px'}}>
                    <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<img style={{width: '15px'}} src="/assets/img/up-chevron.png" />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <span component="span" className="accent-heading" style={{marginBottom: '0'}}>Accordion 1</span>
        </AccordionSummary>
        <AccordionDetails>
          <span className="text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
            malesuada lacus ex, sit amet blandit leo lobortis eget.
          </span>
        </AccordionDetails>
      </Accordion>
      
      <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<img style={{width: '15px'}} src="/assets/img/up-chevron.png" />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <span component="span" className="accent-heading" style={{marginBottom: '0'}}>Accordion 1</span>
        </AccordionSummary>
        <AccordionDetails>
          <span className="text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
            malesuada lacus ex, sit amet blandit leo lobortis eget.
          </span>
        </AccordionDetails>
      </Accordion>
      
      <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<img style={{width: '15px'}} src="/assets/img/up-chevron.png" />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <span component="span" className="accent-heading" style={{marginBottom: '0'}}>Accordion 1</span>
        </AccordionSummary>
        <AccordionDetails>
          <span className="text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
            malesuada lacus ex, sit amet blandit leo lobortis eget.
          </span>
        </AccordionDetails>
      </Accordion>
      
                    </div>
                </div>
            </section>



        </div>
    )
}

export default Home;